import React, { useState, useRef, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { QRCodeCanvas } from "qrcode.react";
import Barcode from "react-barcode";
import { BrowserMultiFormatReader } from "@zxing/library";
import { useLiffProfile } from "../../context/LiffProfileContext";
import ProfileWithBackButtonHeader from "../header/ProfileWithBackButtonHeader";
import { useTranslation } from "react-i18next";
import axios from "axios";

const Scan = () => {
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  const [scannedResult, setScannedResult] = useState("");
  const [userData, setUserData] = useState(null);
  const webcamRef = useRef(null);
  const { profile, authToken, userId } = useLiffProfile();
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchUserData = async () => {
      if (!authToken || !userId) {
        console.warn("Missing authToken or userId");
        return;
      }

      try {
        const response = await axios.get(
          `${process.env.REACT_APP_API_URL}/api/users/current/`,
          {
            headers: {
              Authorization: `Bearer ${authToken}`,
              "X-Client-Auth": process.env.REACT_APP_CLIENT_AUTH,
              "x-user-id": userId,
              "Accept-Language": i18n.language.toUpperCase(),
            },
          }
        );
        setUserData(response.data.data);
      } catch (err) {
        console.error(
          "Error fetching user data:",
          err.response?.data || err.message
        );
        setError("Failed to fetch user data");
      }
    };

    fetchUserData();
  }, [authToken, userId]);

  useEffect(() => {
    const codeReader = new BrowserMultiFormatReader();
    const scanBarcode = async () => {
      try {
        if (webcamRef.current) {
          const video = webcamRef.current.video;
          if (video && video.readyState === 4) {
            const result = await codeReader.decodeFromVideoElement(video);
            if (result) {
              setScannedResult(result.text);
            }
          }
        }
      } catch (error) {
        console.warn("Barcode scan error:", error);
      }
    };

    const interval = setInterval(scanBarcode, 1000);
    return () => clearInterval(interval);
  }, []);

  return (
    <div className="bg-secondary-background-gray w-full min-h-screen">
      <ProfileWithBackButtonHeader />

      <div className="w-full flex flex-col px-5 py-4 gap-8 bg-secondary-background-gray">
        {profile && userData ? (
          <div className="w-full flex gap-3 flex-row">
            <img
              className="w-24 h-auto drop-shadow-xl rounded-full border-4 border-secondary-background"
              src={profile.pictureUrl}
              alt="Profile"
            />
            <div className="flex flex-col gap-1 font-medium text-left">
              <div className="text-22">{profile.displayName}</div>
              <div className="text-base">
                <div>{t("big_point_number")}</div>
                <div>{userData.bigCardNumber}</div>
              </div>
            </div>
          </div>
        ) : (
          <div>กำลังโหลดข้อมูลโปรไฟล์...</div>
        )}

        <div className="bg-white flex flex-col items-center gap-7 rounded-2xl border border-overlay-12 py-8">
          {/* <div className="font-medium text-center text-base">
            {userData?.bigCardNumber || "Loading..."}
          </div> */}

          {/* Barcode */}
          {userData?.bigCardNumber && (
            <div>
              <Barcode
                value={userData.bigCardNumber}
                width={2}
                height={80}
                // displayValue={true}
                fontSize={16}
              />
            </div>
          )}

          {userData ? (
            <QRCodeCanvas
              value={userData.bigCardNumber}
              size={184}
              level="H"
              includeMargin={true}
            />
          ) : (
            <p>Loading QR...</p>
          )}
        </div>

        {scannedResult && (
          <div className="mt-4 text-center text-green-700 font-semibold">
            Scanned Result: {scannedResult}
          </div>
        )}

        {error && <div className="text-red-500">{error}</div>}
      </div>
    </div>
  );
};

export default Scan;
